<template>
  <div>
    <section v-if="projects.length == 0">
      <div class="hero is-fullheight"></div>
    </section>

    <section v-if="projects.length > 0" class="project">
      <div class="co-title-container">
        <div class="left">
          <router-link :to="{ path: '/' }">
            <b-button
              size="is-medium"
              class="fas fa-arrow-left back-button"
              rounded
            ></b-button>
          </router-link>
        </div>
        <div class="right">
          <h1 class="title co-title-project">
            <span>{{ projects[id].fields.contentTypeName }}</span>
            <!-- /
            {{ projects[id].fields.title }} -->
          </h1>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="container container-project">
          <figure class="image">
            <img
              :src="projects[id].fields.image.fields.file.url"
              @load="loaded"
            />
          </figure>
          <div
            class="hotspot"
            v-for="hotspot in projects[id].fields.hotspots"
            :key="hotspot.id"
          >
            <router-link
              class="co-main-button"
              :class="hotspot.arrowPosition"
              @click.native="setContentType(hotspot.contentType)"
              :to="{ name: hotspot.slug, params: { id: 0 } }"
              >{{ hotspot.title }}</router-link
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Project',
  props: ['id'],
  data() {
    return {
      loading: true,
      window: {
        width: 0,
        height: 0
      },
      project: {}
    }
  },
  methods: {
    setContentType(contentType) {
      this.$store.commit('projects/SET_CONTENT_TYPE', contentType)
    },
    setHotSpots() {
      var hotspots = document.getElementsByClassName('hotspot')

      for (let i = 0; i < hotspots.length; i++) {
        const hotspot = hotspots[i]

        hotspot.style.left = this.projects[this.id].fields.hotspots[i].x + '%'
        hotspot.style.top = this.projects[this.id].fields.hotspots[i].y + '%'
        hotspot.style.opacity = 1
      }
    },
    handleResize() {
      if (document.getElementsByClassName('image')[0]) {
        let windowHeight = window.innerHeight
        let projectContainer = document.getElementsByClassName(
          'container-wrapper'
        )[0]
        let imageHeight = document.getElementsByClassName('image')[0]
          .offsetHeight
        let navHeight = document.getElementsByClassName('co-main-nav')[0]
          .offsetHeight
        let titleHeight = document.getElementsByClassName(
          'co-title-container'
        )[0].offsetHeight
        let footerHeight = document.getElementsByClassName('footer')[0]
          .offsetHeight
        let sumHeight = navHeight + titleHeight + footerHeight
        let projectHeight = windowHeight - sumHeight

        if (imageHeight < projectHeight) {
          projectContainer.style.height = projectHeight + 'px'
        } else {
          projectContainer.style.height = imageHeight + 'px'
        }
        document
          .getElementsByClassName('container-project')[0]
          .classList.add('loaded')
      }
    },
    loaded() {
      this.setHotSpots()
      this.handleResize()
    }
  },
  created() {
    this.$store.commit('mainnav/HIDE_MAINNAV')
    document.getElementsByClassName('headline')[0].classList.remove('remove')
    setTimeout(() => {
      document.getElementsByClassName('headline')[0].classList.remove('hide')
    }, 300)
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // document.getElementsByClassName('headline')[0].classList.add('hide')
  },
  destroyed() {
    this.$store.commit('hotspot/SET_HOTSPOT', {})
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState('projects', ['projects'])
  }
}
</script>

<style lang="scss" scoped></style>
